// @ is an alias to /src

export default {
  name: 'SettingLayout',
  components: { 
  },
  data: () => ({
  }),
}